var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00039 2.40002H18.0004C19.9886 2.40002 21.6004 4.0118 21.6004 6.00002V18C21.6004 19.9882 19.9886 21.6 18.0004 21.6H6.00039C4.01217 21.6 2.40039 19.9882 2.40039 18V6.00002C2.40039 4.0118 4.01217 2.40002 6.00039 2.40002Z",
    fill: "#2346F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83208 11.136C8.36043 10.6705 7.60064 10.6754 7.13506 11.147C6.66947 11.6187 6.67439 12.3785 7.14605 12.8441L10.1952 15.854C10.6968 16.3491 11.5152 16.3074 11.9638 15.7637L16.9146 9.7637C17.3364 9.25251 17.264 8.49618 16.7528 8.07438C16.2416 7.65258 15.4853 7.72504 15.0635 8.23622L10.9476 13.2243L8.83208 11.136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxActive);
export default __webpack_public_path__ + "static/media/checkBoxActive.3869fcbb7e247ca441560e97cb127a18.svg";
export { ForwardRef as ReactComponent };